// Languages (Settings) strings — EN + TR.
//
// Wave-1 Day 3 self-wire. Locale switcher kendi UI'sının title/description/
// toast strings'lerini dictionary'den okur → kullanıcı dil değiştirir, başlık
// + tüm metin anında çevrilir (canlı demo, en ironik bug fix).
//
// Source: features/settings/Languages.tsx.

import type { LocalizedDict } from '../index'

type LanguagesStrings = {
  pageTitle: string
  pageDescription: string
  sectionTitle: string
  sectionDescription: string
  englishLabel: string
  englishDescription: string
  turkishLabel: string
  turkishDescription: string
  germanLabel: string
  germanDescription: string
  comingInM3Suffix: string
  m3UnavailableDescription: string
  toastTitle: string
  toastDescription: string
  footerNote: string
  m3Badge: string
}

export const languagesI18n: LocalizedDict<LanguagesStrings> = {
  en: {
    pageTitle: 'Languages',
    pageDescription:
      'Choose the interface language. UI text only — content data (orders, products, customer messages) stays in the language it was authored in.',
    sectionTitle: 'Interface language',
    sectionDescription:
      'Applied to navigation, settings, and operator dialogs.',
    englishLabel: 'English',
    englishDescription: 'Default · covers Wave-1 wired surfaces.',
    turkishLabel: 'Turkish',
    turkishDescription: 'Operator language · Wave-1 cross-shell coverage live.',
    germanLabel: 'German',
    germanDescription: 'B2B reseller surface · M3 ratify.',
    comingInM3Suffix: '· coming in M3',
    m3UnavailableDescription:
      'Translation coverage ships with M3 Stage 4 SPEC.md Faz 6.',
    toastTitle: 'Interface language updated',
    toastDescription:
      'Interface language applies immediately across all wired PEXIFY surfaces.',
    footerNote:
      'Placeholder section · backend binding pending M3 Stage 4 SPEC.md Faz 6 (workspace + resources expansion).',
    m3Badge: 'M3',
  },
  tr: {
    pageTitle: 'Diller',
    pageDescription:
      'Arayüz dilini seç. Sadece arayüz metinleri — içerik verileri (siparişler, ürünler, müşteri mesajları) yazıldığı dilde kalır.',
    sectionTitle: 'Arayüz dili',
    sectionDescription: 'Gezinme, ayarlar ve operatör diyaloglarında uygulanır.',
    englishLabel: 'İngilizce',
    englishDescription: 'Varsayılan · Wave-1 bağlanan yüzeyleri kapsar.',
    turkishLabel: 'Türkçe',
    turkishDescription:
      'Operatör dili · Wave-1 kabuklar arası kapsam aktif.',
    germanLabel: 'Almanca',
    germanDescription: 'B2B reseller yüzeyi · M3 ratify.',
    comingInM3Suffix: '· M3\'te geliyor',
    m3UnavailableDescription:
      'Çeviri kapsamı M3 Stage 4 SPEC.md Faz 6 ile gelir.',
    toastTitle: 'Arayüz dili güncellendi',
    toastDescription:
      'Arayüz dili tüm bağlanan PEXIFY yüzeylerinde anında uygulanır.',
    footerNote:
      'Yer tutucu bölüm · backend bağlama M3 Stage 4 SPEC.md Faz 6 (workspace + resources genişlemesi) ile gelir.',
    m3Badge: 'M3',
  },
}
